import { render, staticRenderFns } from "./UploadedPage.vue?vue&type=template&id=3a000e58&"
import script from "./UploadedPage.vue?vue&type=script&lang=js&"
export * from "./UploadedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports